import template from 'text!./InitialScreen/InitialScreen.html';
import controller from './InitialScreen/InitialScreen';

/**
 * @ngdoc component
 * @name gw-portals-cp-components-angular: gwBuildingsWizard
 *
 * @description  A component to display locations and buildings page.
 *
 */
export default {
  controller: controller,
  template: template
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/index.js
// module id = 1002
// module chunks = 0